import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-page-tg-tourism',
  templateUrl: './home-page-tg-tourism.component.html',
  styleUrls: ['./home-page-tg-tourism.component.scss'],
})
export class HomePageTgTourismComponent implements OnInit {

  constructor() { }

  ngOnInit() { }

}
